var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#808080",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M735 4676 c-139 -44 -243 -147 -285 -285 -20 -62 -20 -99 -20 -2010 l0 -1946 423 423 422 422 1520 0 c988 0 1535 4 1564 11 123 28 235 119 293 236 l33 68 0 1390 0 1390 -32 67 c-44 94 -109 160 -202 206 l-75 37 -1800 2 c-1433 1 -1809 -1 -1841 -11z m3533 -1688 l2 -1278 -1582 0 -1583 0 -127 -127 -128 -128 0 1401 c0 770 3 1404 7 1407 3 4 772 6 1707 5 l1701 -3 3 -1277z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 3415 l0 -425 210 0 210 0 0 425 0 425 -210 0 -210 0 0 -425z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 2345 l0 -215 210 0 210 0 0 215 0 215 -210 0 -210 0 0 -215z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedbackIcon.247b3ddf45acb8740d2349f63d1387ff.svg";
export { ForwardRef as ReactComponent };